import React from 'react';
import { Author } from '../../api/types/author';
import { PriceTier } from '../../api/types/priceTier';
import { Goal } from '../../api/types/contentManagement';

export interface AppSettingsContextType {
  categories: string[];
  pillarTypes: string[];
  pillarExpertises: string[];
  authors: Author[];
  priceTiers: PriceTier[];
  goals: Goal[];
  collectionContentGroups: { title: string; id: string }[];
  refreshContext: () => void;
}

export const AppSettingsContext = React.createContext<AppSettingsContextType>({
  categories: [],
  pillarTypes: [],
  pillarExpertises: [],
  authors: [],
  priceTiers: [],
  goals: [],
  collectionContentGroups: [],
  refreshContext: () => {},
});
